import { Link } from "react-router-dom";

import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function Footer() {
  return (
    <footer
      className={cn(
        "border-t-3 border-gray-900 dark:border-gray-300",
        theme.colors.cardCream,
        "mt-auto"
      )}
    >
      <div className="mx-auto max-w-6xl px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-600 dark:text-gray-400">
          <p>&copy; {new Date().getFullYear()} Podwise GPT</p>
          <nav className="flex items-center gap-4">
            <Link to="/terms" className="hover:underline">
              Terms
            </Link>
            <Link to="/privacy" className="hover:underline">
              Privacy
            </Link>
            <a href="mailto:quiet.lens2873@fastmail.com" className="hover:underline">
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
